import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { useCollapsibleCard } from './CollapsibleCardContext';
import ExpandIconButton from '../../Button/ExpandIconButton';

const CollapsibleCardExpandButton = () => {
    const { expanded, toggle } = useCollapsibleCard();

    return (
        <ExpandIconButton expand={expanded} onClick={toggle} aria-expanded={expanded} aria-label="expand" size="small">
            <ExpandMoreIcon fontSize="small" />
        </ExpandIconButton>
    );
};

export default CollapsibleCardExpandButton;
